import React from "react";

export default function TextPanel({ video }) {
return (
  <div
    className="
      p-4 flex flex-col gap-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-lg font-semibold">Text</h3>

    {/* Description */}
    <div className="text-sm text-gray-600 dark:text-gray-400">
      Add text overlays / titles
    </div>

    {/* Controls */}
    <div className="space-y-4 text-sm">
      {/* Text input */}
      <input
        placeholder="New title"
        className="
          w-full p-2 rounded-md
          bg-white dark:bg-gray-800
          border border-gray-300 dark:border-gray-700
          text-gray-900 dark:text-gray-100
          placeholder:text-gray-400 dark:placeholder:text-gray-500
          focus:outline-none focus:ring-2 focus:ring-blue-500
        "
      />

      {/* Font size */}
      <label className="flex flex-col gap-1">
        <span className="text-gray-600 dark:text-gray-400">
          Font size
        </span>
        <input
          type="range"
          min={8}
          max={72}
          defaultValue={24}
          className="w-full accent-blue-500"
        />
      </label>

      {/* Add button */}
      <button
        className="
          w-full py-2 rounded-lg
          bg-blue-600 hover:bg-blue-700
          text-white
          transition-colors
        "
      >
        Add
      </button>
    </div>
  </div>
);

}